export const getYtLogoGuidelineSize = (size: number, pageType?: number) => {
  return size;
};
